<template>
    <ul v-if="items.length">
        <li v-for="(item, index) in items" :key="item.Id" class="my-2">
            <span v-if="item.Sub.length" class="inline-flex items-center relative group cursor-pointer" @click="toggleSub(index)">
                <div class="w-20 mr-8 overflow-hidden hidden sm:block">
                    <span v-if="depth == 1" class="h-8 w-full block rounded-r-full transition-all -ml-20 group-hover:-ml-0" :style="{ backgroundColor: `#${item.Color}` }"></span>
                </div>
                <div class="text-white transition-all group-hover:opacity-50 ml-8 sm:ml-0" :class="depth > 1 ? 'text-xl' : 'text-3xl'">{{ item.Name }}</div>
            </span>
            <a v-else class="inline-flex items-center relative group" :href="item.Link" :target="item.IsNewWindow == 1 ? '_blank' : '_self'">
                <div class="w-20 mr-8 overflow-hidden hidden sm:block">
                    <span v-if="depth == 1" class="h-8 w-full block rounded-r-full transition-all -ml-20 group-hover:-ml-0" :style="{ backgroundColor: `#${item.Color}` }"></span>
                </div>
                <div class="text-white transition-all group-hover:opacity-50 ml-8 sm:ml-0" :class="depth > 1 ? 'text-xl' : 'text-3xl'">{{ item.Name }}</div>
            </a>
            <expand-transition>
                <div v-show="index == sub" class="bg-opacity-20 transition-all overflow-hidden" :style="{ backgroundColor: `#${item.Color}` }">
                    <quick-menu :items="item.Sub" :depth="depth + 1" @collapse="sub = -1"> </quick-menu>
                </div>
            </expand-transition>
        </li>
    </ul>
</template>
<script>
import ExpandTransition from "./ExpandTransition.vue";

export default {
    name: "QuickMenu",
    components: { ExpandTransition },
    props: {
        items: {
            type: Array,
            default: [],
        },
        depth: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            url: window.location.protocol + "//" + window.location.host,
            sub: -1,
        };
    },
    methods: {
        toggleSub(index) {
            if (this.sub == index) {
                this.sub = -1;
            } else {
                this.sub = index;
                this.$emit("collapse");
            }
        },
    },
};
</script>

<style scoped>

</style>